/** Meeting credentials stay in the URL fragment; never use a host credential as a guest invitation. */
export function sessionEntryUrl(sessionId:string,token:string,name:string,host=false) {
  const url=new URL('/meet/index.html',window.location.origin);
  const params=new URLSearchParams({token,name,devices:'off',...(host?{host:'1'}:{})});
  url.hash='/room/'+encodeURIComponent(sessionId)+'?'+params;
  return url.toString();
}
